/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Platform_Digest_SubjectInputs */

const en_platform_digest_subject = /** @type {(inputs: Platform_Digest_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your day: ${i?.day}`)
};

const pl_platform_digest_subject = /** @type {(inputs: Platform_Digest_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Twój dzień: ${i?.day}`)
};

/**
* | output |
* | --- |
* | "Your day: {day}" |
*
* @param {Platform_Digest_SubjectInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_digest_subject = /** @type {((inputs: Platform_Digest_SubjectInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Digest_SubjectInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_digest_subject(inputs)
	return en_platform_digest_subject(inputs)
});